import sidebar from './league/under/sidebar'
import migratory from './league/under/migratory'
import ruleScrollbar from './league/common/rule-scrollbar'
import anchorScroll from './league/under/scoped-anchor-scroll'
import calendar from './league/under/calendar'
import racecardScrollbar from './league/under/racecard-scrollbar'
import roundBanner from './league/under/round-banner'

(() => {
  sidebar();
  migratory();
  ruleScrollbar();
  anchorScroll('.le-round-anchor__link[data-scroll]');
  calendar();
  racecardScrollbar();
  roundBanner();
})();
